import React, { useState, useMemo, useEffect } from 'react';
import { OptionsType } from '../../utils/customSelectUtils';
import { commonBackInfo } from '../../utils';
import CustomSelect from '../../components/CustomSelect';
import type { SingleCommonType } from '../../types';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { newsBatePlaceholder } from '../../constants/placeholder';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function NewsBateSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  filterOptions,
  lang,
}: SingleCommonType) {
  // 搜索的数据
  const [searchValue, setSearchValue] = useState('');
  const basicOptions = useMemo(() => {
    if (filterOptions) {
      return (filterOptions || [])?.map((item: string) => {
        return {
          text: item,
          value: item,
        };
      });
    }
    return [];
  }, [filterOptions]);

  const { formatMessage } = useIntl();
  const options: OptionsType = useMemo(() => {
    return basicOptions.filter((item: { text: string }) => {
      if (!searchValue) return true;

      return item.text.toLowerCase().includes(searchValue.toLowerCase());
    });
  }, [basicOptions, searchValue, lang]);

  const {
    selects: newsBeat,
    setSelects: setNewsBeat,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'news_beat',
    options: basicOptions?.map((item: any) => item.value),
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    let news_beat = isAll ? [] : newsBeat;

    onChange?.(
      'newsBate',
      commonBackInfo(
        { news_beat },
        { newsBate: text },
        { isAll, needChangeEntity: true },
      ),
    );
  }, [newsBeat, formatMessage]);

  return (
    <div className={`news-beat-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={newsBatePlaceholder[lang]}
        options={options}
        matchButtonWidth={false}
        basicOptions={basicOptions}
        searchInfo={[searchValue, setSearchValue]}
        selectOptionsInfo={[newsBeat, setNewsBeat]}
        onClear={() => setNewsBeat([])}
        pointKey={FilterButtonPoint.newsBate}
      ></CustomSelect>
    </div>
  );
}
